module.exports = __webpack_public_path__ + "img/emoji-happy.eb90f490.svg";